import React, { useState, useRef, useEffect } from 'react';
import AnnounceKitCore from 'announcekit-react';
import classNames from 'classnames';
import Indicator from './Indicator';

function announcekitBoosterBarFix() {
    setTimeout(() => {
        const cssId = window?.announcekit?.boosters?.bar?.cssid;
        if (cssId) {
            var style = document.createElement('style');
            style.innerHTML = `body.${cssId}-body { height: calc(100vh - 2.5rem) !important}`;
            document.head.appendChild(style);
        }
    }, 1000);
}

const labels = ['ANNOUNCEMENT'];

export default function AnnounceKit({
    currentUser,
    className,
    bottom = false,
    right = false,
    bg = 'bg-blue-700',
    border = null,
}) {
    const [count, setCount] = useState(0);
    const ref = useRef();
    const email = currentUser.email;
    const userEmailDomain = email.slice(email.lastIndexOf('@') + 1);

    useEffect(() => {
        announcekitBoosterBarFix();
    }, []);

    useEffect(() => {
        if (ref.current) {
            ref.current.unread().then(unreadCount => setCount(unreadCount));
        }
    });

    return (
        <button
            className={classNames(
                'relative',
                'bg-white',
                'text-blue-gray-600',
                'hover:bg-blue-gray-100',
                'hover:text-blue-gray-700',
                'active:bg-blue-gray-150',
                'active:text-blue-gray-800',
                'focus:outline-none',
                'focus-visible:ring-2',
                'p-2.5',
                'rounded-full',
                'group',
                'h-10',
                'w-10',
                className,
            )}
            onClick={() => ref.current.open()}
        >
            <AnnounceKitCore
                ref={ref}
                widget="https://announcekit.app/widgets/v2/4noIJW"
                user={{
                    id: currentUser.email || '',
                    email: currentUser.email || '',
                }}
                labels={labels}
                data={{ email_domain: userEmailDomain }}
                widgetStyle={{ display: 'none', visibility: 'hidden' }}
                onWidgetClose={() => setCount(0)}
            />
            <Indicator
                count={count}
                bottom={bottom}
                right={right}
                bg={bg}
                border={border}
            >
                <svg
                    width="16"
                    height="22"
                    viewBox="0 0 16 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.125 17H14.5625V9.03125C14.5625 5.72422 12.118 2.99141 8.9375 2.53672V1.625C8.9375 1.10703 8.51797 0.6875 8 0.6875C7.48203 0.6875 7.0625 1.10703 7.0625 1.625V2.53672C3.88203 2.99141 1.4375 5.72422 1.4375 9.03125V17H0.875C0.460156 17 0.125 17.3352 0.125 17.75V18.5C0.125 18.6031 0.209375 18.6875 0.3125 18.6875H5.375C5.375 20.1359 6.55156 21.3125 8 21.3125C9.44844 21.3125 10.625 20.1359 10.625 18.6875H15.6875C15.7906 18.6875 15.875 18.6031 15.875 18.5V17.75C15.875 17.3352 15.5398 17 15.125 17ZM8 19.8125C7.37891 19.8125 6.875 19.3086 6.875 18.6875H9.125C9.125 19.3086 8.62109 19.8125 8 19.8125ZM3.125 17V9.03125C3.125 7.72813 3.63125 6.50469 4.55234 5.58359C5.47344 4.6625 6.69688 4.15625 8 4.15625C9.30312 4.15625 10.5266 4.6625 11.4477 5.58359C12.3687 6.50469 12.875 7.72813 12.875 9.03125V17H3.125Z"
                        className="fill-current"
                    />
                </svg>
            </Indicator>
        </button>
    );
}
